import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        nav("/login", { replace: true, state: { error: e?.response?.data?.detail || "Login failed" } });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center">
        <div className="animate-pulse text-lg font-semibold text-slate-800">Signing you in…</div>
        <div className="text-sm text-slate-600 mt-2">One moment.</div>
      </div>
    </div>
  );
}
